// extracted by mini-css-extract-plugin
module.exports = {"tray":"Carousel_tray__tstBF","carousel":"Carousel_carousel__wRXRA","slide":"Carousel_slide__J_sel","dotGroup":"Carousel_dotGroup__n2r_e"};